import React from 'react';
import { makeStyles } from '@material-ui/core';

import { units } from '@ha/dsl';

const useStyles = makeStyles(theme => ({
  popoverActionsContainer: {
    paddingBottom: units.rem(1),
    [theme.breakpoints.up('sm')]: {
      paddingRight: units.rem(0.5),
    },
  },
}));

interface Props {
  children: React.ReactNode;
}

const PopoverActions: React.FC<Props> = props => {
  const { children } = props;
  const { popoverActionsContainer } = useStyles();

  return <div className={popoverActionsContainer}>{children}</div>;
};

export default PopoverActions;
